import { getConfig } from '@fec/assets/js/utils/config.js';
import { Webtrekk } from '@aron/common/analytics/Webtrekk.js';
import { IframeTrackingRelay } from '@aron/common/analytics/IframeTrackingRelay.js';

export function init() {
  let config = getConfig();
  if (config.ANALYTICS_WEBTREKK_VALUE_OBJECT) {
    new IframeTrackingRelay(
      new Webtrekk(config.ANALYTICS_WEBTREKK_VALUE_OBJECT),
    );
  }
}
